module.exports = __webpack_public_path__ + "static/media/Payments.1a619b29.svg";